var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, InjectReactive } from 'vue-property-decorator';
import { timeFormat } from '@/common/filters/index';
var CluePopover = /** @class */ (function (_super) {
    __extends(CluePopover, _super);
    function CluePopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CluePopover.prototype, "lockClueLength", {
        get: function () {
            var successClues = this.clueList.filter(function (e) { return e.status === 'SUCCESS'; });
            return successClues.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CluePopover.prototype, "otherShareLimit", {
        get: function () {
            var other = (this.booth.shareLimit - this.lockClueLength) || 0;
            return other;
        },
        enumerable: false,
        configurable: true
    });
    CluePopover.prototype.getItemClass = function (index) {
        if (!this.booth.allowShare && index === this.clueList.length - 1)
            return 'last';
        return '';
    };
    CluePopover.prototype.showClueDetail = function (activity) {
        var clueId = activity.clueId;
        if (this.type === 'static')
            return;
        return window.open("/clue/detail?id=" + clueId);
    };
    // 是否能编辑线索
    CluePopover.prototype.hasClueEdit = function () {
        return this.type !== 'static';
    };
    CluePopover.prototype.clueEditHandle = function (row) {
        this.scheduleData.openEditClueModal(row.clueDetailId, this.sort);
    };
    __decorate([
        InjectReactive('schedule')
    ], CluePopover.prototype, "scheduleData", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; },
        })
    ], CluePopover.prototype, "clueList", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], CluePopover.prototype, "booth", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], CluePopover.prototype, "disabled", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'normal',
        })
    ], CluePopover.prototype, "type", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 0,
        })
    ], CluePopover.prototype, "sort", void 0);
    CluePopover = __decorate([
        Component({
            filters: { timeFormat: timeFormat },
        })
    ], CluePopover);
    return CluePopover;
}(Vue));
export default CluePopover;
